export const getAuthZoneID = () => {
	const { zoneID } = window.lt?.pageProperties?.auth ?? {};
	return zoneID;
};
